import React, { Fragment } from 'preact/compat';
import { ComponentChildren } from 'preact';
import { useFormikContext } from 'formik';
import { useEmailFormContext } from './context';
import { EmailFormValues } from './types';

export default function ConsumerContactRedirect({ children }: ConsumerContactRedirectProps) {
    const {
        consumerContactPages,
        classNames: {
            button: {
                submit: buttonClassName,
            },
        },
    } = useEmailFormContext();
    const {
        values: {
            department,
            productTeam,
        },
    } = useFormikContext<EmailFormValues>();

    if (department === 'consumerCare' && productTeam in consumerContactPages) {
        const { title, contactUrl } = consumerContactPages[productTeam];

        return (
            <div className='form__section'>
                <div className='form__header'>
                    <h2 className='form__heading'>Consumer care enquiry</h2>
                    <p>Please send consumer enquiries via the {title} contact page.</p>
                </div>
                <div className='form__footer'>
                    <a href={contactUrl} className={buttonClassName}>
                        Continue to the {title} website
                    </a>
                </div>
            </div>
        );
    }

    return (
        <Fragment>
            {children}
        </Fragment>
    );
}

type ConsumerContactRedirectProps = {
    children?: ComponentChildren,
};
